import useAxiosInterceptor from '../interceptor';
import { apiPath } from '../apiServices/constants';

class departmentDashboard {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getDepartmentDashboardCount = () => {
    return this.axiosInstance.get(
      `${apiPath.DEPARTMENT_DASHBOARD}?date=${new Date().toISOString().split('T')[0]}`
    );
  };
  getDepartmentPTORequest = (data: any) => {
    return this.axiosInstance.get(
      `/provider/availability/get-pto-requests/department?ptoStatus=${data?.payload?.status}`
    );
  };

  checkTaskPTO = (payload: any) => {
    return this.axiosInstance.get(
      `/provider/availability/is-patient-scheduled/${payload?.payload?.ptoRequestId}`
    );
  };

  getDepartmentTherapyMins = () => {
    return this.axiosInstance.get(
      `/provider/department/dashboard/therapy-minutes-average?date=${
        new Date().toISOString().split('T')[0]
      }`
    );
  };
  updateDepartmentPTORequest = (data: any) => {
    return this.axiosInstance.put(`/provider/availability/approve-reject-pto`, data?.payload);
  };

  getSupervisorAlert = (payload: any) => {
    return this.axiosInstance.post(`provider/dashboardOverview/visit-alert`, payload?.body, {
      params: payload?.params,
    });
  };

  getSupervisorAlertSetting = (payload: any) => {
    return this.axiosInstance.get(`provider/dashboardOverview/visit-alert/available-discipline`);
  };

  getPhysicianSignaturePending = (payload: any) => {
    return this.axiosInstance.get(`/provider/compliance/pending-signatures`, {
      params: payload,
    });
  };

  getAllPhysicians = (payload: any) => {
    return this.axiosInstance.get(`/provider/physician/list`, {
      params: payload,
    });
  };

  getPendingSignaturePhysicians = () => {
    return this.axiosInstance.get(`/provider/compliance/pending-signatures/physicians`);
  };
}

const departmentDashboardService = new departmentDashboard();

Object.freeze(departmentDashboardService);

export default departmentDashboardService;
